import {
    IPoint,
    IPointData,
    POINT_NAME_MAX_LENGTH,
    POINT_DESCRIPTION_MAX_LENGTH,
    ICity, City
} from './index'
import {Criterion} from '../../../abstract'

export class Point extends Criterion<string> implements IPoint {
    city?: ICity
    latitude?: number
    longitude?: number
    constructor(data?: IPointData) {
        super(data)
        let city = data?.city
        this.city = city ? new City(city) : undefined
        this.latitude = data?.latitude 
        this.longitude = data?.longitude
    }

    validate(): boolean {
        return (this.validateName() && this.validateDescription())
    }

    validateName(): boolean {
        let name = this.name
        return !!name && name.length <= POINT_NAME_MAX_LENGTH
    }

    validateDescription(): boolean {
        let desc = this.description
        return !desc || desc.length <= POINT_DESCRIPTION_MAX_LENGTH
    }

    update(data?: IPointData): void {
        super.update(data)
        let city = data?.city
        if (city) {
          this.city?.update(city)
        }
    }

    get path(): string {
        let city = this.city
        return this.name + (city ? (', ' + city.path) : '')
    }

}